import React from "react";
import { Table } from "reactstrap";
import moment from "moment";
import { calcPercentage } from "../../Utils/calculate-progress.js";
import { formatDate } from "../../Utils/format-date.js";
import { addClassName } from "../../Utils/Add-ClassName.js";
import { addButton } from "../../Utils/addButtons.js";
import OpPopover from "../../Components/PopOver/Popover";
import info_black_24dp from "../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "./popover-inner-content";
import completed from "../../../images/new-images/completed.png";
import Emptyassessment from "./empty-assessment";
import './my-assessment-table.css'
import { LoaderComp } from "../../../_components/common/LoaderComp/Loadercomp.js";

const Rendermyassessmenttable = (props) => {

  const currentDate = moment().format("YYYY-MM-DD");



  if (props.loading) {
    return (
      <div className="loader-container">
        <LoaderComp color={'black'} />
      </div>
    );
  }

  if (props.userAssessmentDetails.length === 0) {
    return <Emptyassessment />;
  }


  return (
    <Table>
      <thead>
        <tr>
          <th className="tableHeaders">Assessment Type</th>
          <th className="tableHeaders">Date Of Expiry</th>
          <th className="tableHeaders">Status</th>
          <th className="tableHeaders">Action</th>
        </tr>
      </thead>
      <tbody>
        {props.userAssessmentDetails.map((assessment, index) => {
          return (
            <tr key={index}>
              <td>
                <div className="assessmentType" style={{ display: 'flex', alignItems: 'center', alignContent: 'center' }}>
                  <img
                    className="assessmentIcon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      assessment.instrument__instrument_image
                    }
                  />
                  <div className="assessmentName">
                    {assessment.instrument__dashboard_header_text}
                  </div>
                  <OpPopover
                    positions={["right"]}
                    align={"center"}
                    targtElement={
                      <img className="infoIcon" src={info_black_24dp} style={{ marginTop: '7px' }} />
                    }
                    isOpen={
                      props.isPopOverOpenAssessmentId === assessment.id
                    }
                    setOpen={(bool) => {
                      props.handleAssessmentPopOver(
                        bool ? assessment.id : false
                      );
                    }}
                  >
                    <Renderpopoverinnercontent
                      handleClosePopOver={props.handleClosePopOver}
                      assessmentheading={
                        assessment.instrument__dashboard_header_text
                      }
                      assesmentdescription={
                        assessment.instrument__dashboard_header_description
                      }
                    />
                  </OpPopover>
                </div>
                <div className="userName">
                  {assessment.participant__full_name}'s
                  <span>{assessment.instrument__instrument_name}</span>
                </div>
              </td>
              <td>
                <div className="Date">
                  {formatDate(assessment.expiry_date)}
                </div>
              </td>
              <td>
                {currentDate > assessment.expiry_date ? (
                  <div
                    style={{ color: "#aaaaaa" }}
                    className={"assessment-status-text"}
                  >
                    Expired
                  </div>
                ) : assessment.assessment_status__status_name ===
                  "Report in review" ? (
                  <div
                    className={
                      "assessment-status-text " +
                      addClassName(
                        assessment.assessment_status__status_name
                      )
                    }
                  >
                    Completed
                    <img src={completed} alt="Completed Image" />
                  </div>
                ) : assessment.respondent_completed >=
                  assessment.batch__min_respondent ? (
                  <div
                    className={
                      "assessment-status-text " +
                      addClassName(
                        assessment.assessment_status__status_name
                      )
                    }
                  >
                    Completed
                    <span>
                      ({assessment.batch__min_respondent}/
                      {assessment.batch__min_respondent})
                    </span>
                  </div>
                ) : assessment.assessment_status__status_name ===
                  "Yet to start" ? (
                  <div
                    className={
                      "assessment-status-text " +
                      addClassName(
                        assessment.assessment_status__status_name
                      )
                    }
                  >
                    {assessment.assessment_status__status_name}
                  </div>
                ) : assessment.assessment_status__status_name ===
                  "In progress" ? (
                  <div
                    style={{ display: "flex" }}
                    className={
                      "assessment-status-text " +
                      addClassName(
                        assessment.assessment_status__status_name
                      )
                    }
                  >
                    {assessment.assessment_status__status_name}
                    {calcPercentage(
                      assessment.assessment_number_count,
                      assessment.assessment_completed_count
                    )}
                  </div>
                ) : assessment.respondent_completed <
                  assessment.batch__min_respondent ? (
                  <div
                    className={
                      "assessment-status-text " +
                      addClassName(
                        assessment.assessment_status__status_name
                      )
                    }
                  >
                    Completed
                    <span>
                      ({assessment.respondent_completed}/
                      {assessment.respondent_count})
                    </span>
                  </div>
                ) : null}
              </td>
              <td>
                {addButton(
                  assessment,
                  props.handleMouseEnter,
                  props.handleModalClose,
                  props.reportNotification
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default Rendermyassessmenttable;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-assessments/my-assessment-table.jsx